export default __webpack_public_path__ + "static/media/logoVashoIconDark.79907e08.png";